module.exports = __webpack_public_path__ + "static/media/default-avatar-filled.6d578bac.svg";